import { Link } from "react-router-dom";
import type { MockMovie } from "@/mocks/movies";
import MovieCard from "@/components/base/MovieCard";

interface MovieSectionProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  movies: MockMovie[];
  moreTo?: string;
  moreLabel?: string;
}

export default function MovieSection({
  eyebrow,
  title,
  subtitle,
  movies,
  moreTo,
  moreLabel = "查看更多",
}: MovieSectionProps) {
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
        <div className="min-w-0">
          {eyebrow && (
            <span className="inline-flex items-center gap-1.5 text-accent-600 text-xs font-semibold uppercase tracking-wider mb-1.5">
              <span className="w-4 h-0.5 bg-accent-500 rounded-full" />
              {eyebrow}
            </span>
          )}
          <h2 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950">{title}</h2>
          {subtitle && <p className="mt-1 text-xs md:text-sm text-foreground-600">{subtitle}</p>}
        </div>
        {moreTo && (
          <Link
            to={moreTo}
            className="shrink-0 inline-flex items-center gap-1 text-sm text-primary-600 hover:text-accent-600 font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            {moreLabel}
            <i className="ri-arrow-right-s-line text-lg" />
          </Link>
        )}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-5">
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}